module.exports = __webpack_public_path__ + "static/media/Group 6991.bb1bea72.svg";